import { render } from "./TermOfUseView.vue?vue&type=template&id=7cdcd278&scoped=true"
import script from "./TermOfUseView.vue?vue&type=script&lang=js"
export * from "./TermOfUseView.vue?vue&type=script&lang=js"

import "./TermOfUseView.vue?vue&type=style&index=0&id=7cdcd278&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdcd278"]])

export default __exports__